import Vue from 'vue'
import Router from 'vue-router'

import {
	routerMap
} from './router-map'


Vue.use(Router)

export const constantRoutes = [{
		path: '/login',
		name: 'login',
		hidden: true,
		meta: {
			title: '登录',
			icon: ''
		},
		component: routerMap['login']
	}, {
		path: '/register',
		name: 'register',
		hidden: true,
		meta: {
			title: '注册',
			icon: ''
		},
		component: routerMap['register']
	}, {
		path: '/forget',
		name: 'forget',
		hidden: true,
		meta: {
			title: '忘记密码',
			icon: ''
		},
		component: routerMap['forget'],
	}, {
		path: '/authLogin',
		name: 'authLogin',
		hidden: true,
		meta: {
			title: '自动登录',
			icon: ''
		},
		component: routerMap['authLogin'],
	},
	{
		path: '/expire',
		component: routerMap['errorExpire'],
		meta: {
			title: '系统已到期',
			leaf: false,
		},
		hidden: true
	},
]


// 异步挂载的路由
// 动态需要根据权限加载的路由表
export const asyncRoutes = [{
	path: '/',
	component: routerMap['layout'],
	name: 'layout',
	children: [{
			path: '/index',
			name: 'index',
			component: routerMap['index'],
			meta: {
				title: '',
				msg: "首页",
				leaf: false,
				icon: 'sidebar-home'
			},
			children: []
		},
		{
			path: '/report',
			name: 'report',
			component: routerMap['report'],
			// redirect: '/reportOverView',
			meta: {
				title: '数据中心',
				msg: "数据中心",
				leaf: true,
				icon: 'sidebar-report'
			},
			children: [{
				path: '/todayReportView',
				name: 'todayReportView',
				component: routerMap['todayReportView'],
				meta: {
					title: '今日数据',
					leaf: false,
				},
				children: []
			},{
				path: '/reportOverView',
				name: 'reportOverView',
				component: routerMap['reportOverView'],
				meta: {
					title: '会话数据',
					leaf: false,
				},
				children: []
			}, {
				path: '/reportLeaveWords',
				name: 'reportLeaveWords',
				component: routerMap['reportLeaveWords'],
				meta: {
					title: '留言数据',
					leaf: false,
				},
				children: []
			}, {
				path: '/reportShopData',
				name: 'reportShopData',
				component: routerMap['reportShopData'],
				meta: {
					title: '商城数据',
					leaf: false,
				},
				children: []
			}, {
				path: '/reportWebsite',
				name: 'reportWebsite',
				component: routerMap['reportWebsite'],
				meta: {
					title: '访问轨迹',
					leaf: false,
				},
				children: []
			}, {
				path: '/keywordData',
				name: 'keywordData',
				component: routerMap['keywordData'],
				meta: {
					title: '关键词统计',
					leaf: false,
				},
				children: []
			}]
		},
		{
			path: '/reportStatistics',
			name: 'reportStatistics',
			component: routerMap['report'],
			meta: {
				title: '报表统计',
				msg: "报表统计",
				leaf: true,
				icon: 'sidebar-statistics'
			},
			children: [{
				path: '/report-service-workreport',
				name: 'reportServiceWorkReport',
				component: routerMap['reportServiceWorkReport'],
				meta: {
					title: '回复解决率',
					leaf: false,
				},
				children: []
			}, {
				path: '/report-service-qualityreport',
				name: 'reportServiceQualityReport',
				component: routerMap['reportServiceQualityReport'],
				meta: {
					title: '满意度报表',
					leaf: false,
				},
				children: []
			}]
		},
		{
			path: '/history',
			name: 'history',
			component: routerMap['historyChat'],
			meta: {
				title: '会话记录',
				msg: "会话记录",
				leaf: false,
				icon: 'sidebar-history'
			},
			children: []
		},
		{
			path: '/service',
			name: 'service',
			component: routerMap['service'],
			meta: {
				title: '客服管理',
				msg: "客服管理",
				leaf: true,
				icon: 'sidebar-service'
			},
			children: [{
				path: '/service-all',
				name: 'serviceAll',
				component: routerMap['serviceAll'],
				meta: {
					title: '客服信息',
					leaf: false,
					hasFourth: true,
					lastLevelMenu: true, // 是否是最后一级菜单
				},
				children: [{
						path: '/service-all-list',
						name: 'serviceAllList',
						component: routerMap['serviceAll'],
						meta: {
							title: '所有客服',
							leaf: false,
						},
						children: []
					},
					{
						path: '/service-add',
						name: 'serviceAdd',
						component: routerMap['serviceAddEdit'],
						meta: {
							title: '添加子账号',
							leaf: false,
						},
						children: []
					}, {
						path: '/service-edit',
						name: 'serviceEdit',
						component: routerMap['serviceAddEdit'],
						meta: {
							title: '编辑',
							leaf: false,
						},
						children: []
					}
				]
			}, {
				path: '/service-role-setting',
				name: 'serviceRoleSetting',
				redirect: '/service-role-list',
				component: routerMap['serviceRoleSetting'],
				meta: {
					title: '角色管理',
					leaf: false,
					hasFourth: true,
					lastLevelMenu: true, // 是否是最后一级菜单
				},
				children: [{
						path: '/service-role-list',
						name: 'serviceRoleSettingList',
						component: routerMap['serviceRoleSettingList'],
						meta: {
							title: '所有角色',
							leaf: false,
						},
						children: []
					},
					{
						path: '/service-role-add',
						name: 'serviceRoleSettingAdd',
						component: routerMap['serviceRoleSettingAddEdit'],
						meta: {
							title: '添加角色',
							leaf: false,
						},
						children: []
					}, {
						path: '/service-role-edit',
						name: 'serviceRoleSettingEdit',
						component: routerMap['serviceRoleSettingAddEdit'],
						meta: {
							title: '编辑角色',
							leaf: false,
						},
						children: []
					}
				]
			}, {
				path: '/service-quality',
				name: 'serviceQuality',
				component: routerMap['serviceQuality'],
				meta: {
					title: '评价统计',
					leaf: false,
					hasFourth: false,
					lastLevelMenu: true, // 是否是最后一级菜单
				},
				children: []
			}, {
				path: '/service-today-activity',
				name: 'serviceTodayActivity',
				component: routerMap['serviceTodayActivity'],
				meta: {
					title: '今日客服活动',
					leaf: false,
					hasFourth: false,
					lastLevelMenu: true, // 是否是最后一级菜单
				},
				children: []
			},]
		},
		{
			path: '/order',
			name: 'order',
			component: routerMap['order'],
			meta: {
				title: '工单管理',
				msg: "工单管理",
				leaf: true,
				icon: 'workOrder'
			},
			children: [{
				path: '/tobeprocessed-order',
				name: 'toBeProcessedOrder',
				component: routerMap['toBeProcessedOrder'],
				meta: {
					title: '待处理工单',
					leaf: false,
					hasFourth: true,
					lastLevelMenu: true, // 是否是最后一级菜单
				},
				children: [{
						path: '/tobeprocessed-order-list',
						name: 'toBeProcessedOrderList',
						component: routerMap['toBeProcessedOrderList'],
						meta: {
							title: '工单列表',
							leaf: false,
						},
						children: []
					}, {
						path: '/toBeProcessed-order-details',
						name: 'toBeProcessedOrderDetail',
						component: routerMap['workOrderDetail'],
						meta: {
							title: '工单详情',
							leaf: false,
						},
						children: []
					}
				]

			}, {
				path: '/resolved-order',
				name: 'resolvedOrder',
				component: routerMap['resolvedOrder'],
				meta: {
					title: '已解决工单',
					leaf: false,
					hasFourth: true,
					lastLevelMenu: true, // 是否是最后一级菜单
				},
				children: [{
						path: '/resolved-order-list',
						name: 'resolvedOrderList',
						component: routerMap['resolvedOrderList'],
						meta: {
							title: '工单列表',
							leaf: false,
						},
						children: []
					}, {
						path: '/resolved-order-details',
						name: 'resolvedOrderDetail',
						component: routerMap['workOrderDetail'],
						meta: {
							title: '工单详情',
							leaf: false,
						},
						children: []
					}
				]

			}, {
				path: '/closed-order',
				name: 'closedOrder',
				component: routerMap['closedOrder'],
				meta: {
					title: '已关闭工单',
					leaf: false,
					hasFourth: true,
					lastLevelMenu: true, // 是否是最后一级菜单
				},
				children: [{
						path: '/closed-order-list',
						name: 'closedOrderList',
						component: routerMap['closedOrderList'],
						meta: {
							title: '工单列表',
							leaf: false,
						},
						children: []
					}, {
						path: '/closed-order-details',
						name: 'closedOrderDetail',
						component: routerMap['workOrderDetail'],
						meta: {
							title: '工单详情',
							leaf: false,
						},
						children: []
					}
				]
			}]
		},
		{
			path: '/ai-customer',
			name: 'aiCustomer',
			redirect: '/ai-customer-service',
			component: routerMap['setting'],
			meta: {
				title: 'AI客服',
				msg: "AI客服",
				leaf: false,
				icon: 'sidebar-ai'
			},
			children: [{
				path: '/ai-customer-service',
				name: 'aiCustomerService',
				component: routerMap['aiCustomerService'],
				meta: {
					title: 'AI客服',
					leaf: false,
				},
				children: []
			}, {
				path: '/ai-customer-guide',
				name: 'aiCustomerGuide',
				component: routerMap['aiCustomerGuide'],
				meta: {
					title: '引导设置',
					leaf: false,
				},
				children: []
			}, {
				path: '/ai-customer-material',
				name: 'aiCustomerMaterial',
				component: routerMap['aiCustomerMaterial'],
				meta: {
					title: '素材库',
					leaf: false,
				},
				children: []
			}, {
				path: '/ai-customer-knowledge',
				name: 'aiCustomerKnowledge',
				component: routerMap['aiCustomerKnowledge'],
				meta: {
					title: '知识库',
					leaf: false,
				},
				children: []
			}, {
				path: '/ai-customer-link',
				name: 'aiCustomerLink',
				component: routerMap['aiCustomerLink'],
				meta: {
					title: '链接库',
					leaf: false,
				},
				children: []
			}]
		},
		{
			path: '/robot',
			name: 'robot',
			component: routerMap['setting'],
			meta: {
				title: '智能机器人',
				msg: "智能机器人",
				leaf: false,
				icon: 'sidebar-robot'
			},
			children: [{
				path: '/setting-advanced-robot',
				name: 'settingAdvancedRobot',
				component: routerMap['settingAdvancedRobot'],
				meta: {
					title: '机器人',
					leaf: false,
				},
				children: []
			}, {
				path: '/setting-advanced-knowledge',
				name: 'settingAdvancedKnowledge',
				redirect: "/setting-advanced-knowledge-management",
				component: routerMap['settingAdvancedKnowledge'],
				meta: {
					title: '知识库',
					leaf: true,
					hasFourth: true,
					lastLevelMenu: true, // 是否是最后一级菜单
				},
				children: [{
					path: '/setting-advanced-knowledge-management',
					name: 'settingAdvancedKnowledgeManagement',
					component: routerMap['settingAdvancedKnowledgeManagement'],
					meta: {
						title: '知识库管理',
						leaf: false
					},
					children: []
				}, {
					path: '/setting-advanced-knowledge-category',
					name: 'settingAdvancedKnowledgeCategory',
					component: routerMap['settingAdvancedKnowledgeCategory'],
					meta: {
						title: '分类列表',
						leaf: false
					},
					children: []
				}, {
					path: '/setting-advanced-knowledge-addOrEdit',
					name: 'settingAdvancedKnowledgeAddOrEdit',
					component: routerMap['settingAdvancedKnowledgeAddOrEdit'],
					meta: {
						title: '知识库问题管理',
						leaf: false,
						hidden:true,
					},
					children: []
				}]
			}, {
				path: '/setting-advanced-greetLibrary',
				name: 'settingAdvancedGreetLibrary',
				component: routerMap['settingAdvancedGreetLibrary'],
				meta: {
					title: '寒暄库',
					leaf: false,
				},
				children: []
			}]
		},
		{
			path: '/setting',
			name: 'setting',
			redirect: '/setting-visitor',
			component: routerMap['setting'],
			meta: {
				title: '系统设置',
				msg: "系统设置",
				leaf: true,
				icon: 'sidebar-setting'
			},
			children: [{
					path: '/setting-visitor',
					name: 'settingVisitor',
					component: routerMap['settingSystem'],
					// redirect: '/setting-userinfo',
					meta: {
						title: '访客设置',
						leaf: true,
					},
					children: [{
							path: '/setting-visitor-info',
							name: 'settingVisitorInfo',
							component: routerMap['settingVisitorInfo'],
							meta: {
								title: '访客信息',
								leaf: false,
							},
							children: []
						},
						{
							path: '/setting-advanced-tag',
							name: 'settingAdvancedTag',
							component: routerMap['settingAdvancedTag'],
							meta: {
								title: '访客标签',
								leaf: false,
							},
							children: []
						},
						{
							path: '/setting-advanced-black-list',
							name: 'settingAdvancedBlackList',
							component: routerMap['settingAdvancedBlackList'],
							meta: {
								title: '黑名单',
								leaf: true,
								hasFourth: true
							},
							children: [
								{
									path: '/setting-advanced-black-list-setting',
									name: 'settingAdvancedBlackListSetting',
									redirect: '/setting-advanced-visitor-blacklist',
									component: routerMap['settingAdvancedBlackListSetting'],
									meta: {
										title: '设置',
										leaf: false,
									},
									children: [{
										path: '/setting-advanced-visitor-blacklist',
										name: 'settingAdvancedVisitorBlackList',
										component: routerMap['settingAdvancedVisitorBlackList'],
										meta: {
											title: '访客黑名单',
											leaf: false,
										},
										children: []
									}, {
										path: '/setting-advanced-ip-blacklist',
										name: 'settingAdvancedIpBlackList',
										component: routerMap['settingAdvancedIpBlackList'],
										meta: {
											title: 'IP黑名单',
											leaf: false,
										},
										children: []
									}, ]
								}, 
							]
						},
						{
							path: '/shopconfig',
							name: 'settingShopConfig',
							component: routerMap['settingShopConfig'],
							meta: {
								title: '购物设置',
								leaf: false,
							},
							children: []
						},
					]
				},
				{
					path: '/setting-chat',
					name: 'settingChat',
					component: routerMap['settingSystem'],
					// redirect: '/setting-userinfo',
					meta: {
						title: '会话设置',
						leaf: true,
					},
					children: [{
							path: '/setting-advanced-chat-invite',
							name: 'settingAdvancedChatInvite',
							component: routerMap['settingAdvancedChatInvite'],
							meta: {
								title: '会话邀请语',
								leaf: false,
							},
							children: []
						},
						{
							path: '/setting-online-base',
							name: 'settingOnlineBase',
							component: routerMap['settingOnlineBase'],
							meta: {
								title: '欢迎结束语',
								leaf: false,
							},
							children: []
						},
						{
							path: '/setting-advanced-reply',
							name: 'settingAdvancedReply',
							// redirect:'/setting-advanced-reply-company',
							component: routerMap['settingAdvancedReply'],
							meta: {
								title: '快捷回复语',
								leaf: true,
								hasFourth: true
							},
							children: [{
								path: '/setting-advanced-reply-company',
								name: 'settingAdvancedCompanyReply',
								component: routerMap['settingAdvancedCompanyReply'],
								meta: {
									title: '企业回复',
									leaf: false
								},
								children: []
							}, {
								path: '/setting-advanced-reply-personal',
								name: 'settingAdvancedPersonalReply',
								component: routerMap['settingAdvancedPersonalReply'],
								meta: {
									title: '个人回复',
									leaf: false
								},
								children: []
							}, {
								path: '/setting-advanced-reply-category',
								name: 'settingAdvancedReplyCategory',
								component: routerMap['settingAdvancedReplyCategory'],
								meta: {
									title: '分类列表',
									leaf: false
								},
								children: []
							}, ]
						},
						{
							path: '/setting-advanced-qrcode',
							name: 'settingAdvancedQRCode',
							component: routerMap['settingAdvancedQRCode'],
							meta: {
								title: '快捷名片',
								leaf: false,
							},
							children: []
						},
						{
							path: '/setting-online-chat-overtime',
							name: 'settingOnlineChatOvertime',
							component: routerMap['settingOnlineChatOvertime'],
							meta: {
								title: '等待引导语',
								leaf: false,
							},
							children: []
						},
						{
							path: '/setting-online-satisfaction',
							name: 'settingOnlineSatisfaction',
							component: routerMap['settingOnlineSatisfaction'],
							meta: {
								title: '评价引导语',
								leaf: false,
							},
							children: []
						},
						{
							path: '/setting-online-leave-msg',
							name: 'settingOnlineLeaveMsg',
							component: routerMap['settingOnlineLeaveMsg'],
							meta: {
								title: '留言提示语',
								leaf: false,
							},
							children: []
						},
						{
							path: '/setting-online-lineup',
							name: 'settingOnlineLineUp',
							component: routerMap['settingOnlineLineUp'],
							meta: {
								title: '排队权限',
								leaf: false,
							},
							children: []
						},
						{
							path: '/setting-online-distribution',
							name: 'settingOnlineDistribution',
							// redirect: '/setting-online-distribution-setting',
							component: routerMap['settingOnlineDistribution'],
							meta: {
								title: '会话分配',
								leaf: true,
								hasFourth: true
							},
							children: [{
								path: '/setting-online-distribution-setting',
								name: 'settingOnlineDistributionSetting',
								redirect: '/setting-online-distribution-rules',
								component: routerMap['settingOnlineDistributionSetting'],
								meta: {
									title: '设置',
									leaf: false,
								},
								children: [{
									path: '/setting-online-distribution-rules',
									name: 'settingOnlineDistributionRules',
									component: routerMap['settingOnlineDistributionRules'],
									meta: {
										title: '分配规则',
										leaf: false,
									},
									children: []
								}, {
									path: '/setting-online-distribution-sort',
									name: 'settingOnlineDistributionSort',
									component: routerMap['settingOnlineDistributionSort'],
									meta: {
										title: '客服排序',
										leaf: false,
									},
									children: []
								}, ]
							}, ]
						},
						{
							path: '/setting-online-msg-voice',
							name: 'settingOnlineMsgVocie',
							component: routerMap['settingOnlineMsgVocie'],
							meta: {
								title: '消息声音',
								leaf: false,
							},
							children: []
						},
						{
							path: '/setting-online-chat-box',
							name: 'settingOnlineChatBox',
							component: routerMap['settingOnlineChatBox'],
							meta: {
								title: '会话框设置',
								leaf: false,
							},
							children: []
						},
						{
							path: '/setting-online-whiteList',
							name: 'settingOnlineWhiteList',
							component: routerMap['settingOnlineWhiteList'],
							meta: {
								title: '屏蔽网站设置',
								leaf: false,
							},
							children: []
						},
					]
				},
				{
					path: '/setting-service',
					name: 'settingService',
					component: routerMap['settingOnline'],
					// redirect: '/setting-online-base',
					meta: {
						title: '服务设置',
						leaf: true,
					},
					children: [{
							path: '/setting-advanced-mass',
							name: 'settingAdvancedMass',
							component: routerMap['settingAdvancedMass'],
							meta: {
								title: '群发助手',
								leaf: false,
							},
							children: []
						},
						{
							path: '/setting-advanced-voice',
							name: 'settingAdvancedVoice',
							component: routerMap['settingAdvancedVoice'],
							meta: {
								title: '语音消息',
								leaf: false,
							},
							children: []
						},
						{
							path: '/setting-advanced-msg',
							name: 'settingAdvancedMsg',
							component: routerMap['settingAdvancedMsg'],
							// redirect: '/setting-advanced-msg-record-send',
							meta: {
								title: '短信服务',
								leaf: true,
								hasFourth: true
							},
							children: [{
									path: '/setting-advanced-msg-record-send',
									name: 'settingAdvancedMsgRecordSend',
									component: routerMap['settingAdvancedMsgRecordSend'],
									meta: {
										title: '发送记录',
										leaf: false,
									},
									children: []
								},
								{
									path: '/setting-advanced-msg-record-recharge',
									name: 'settingAdvancedMsgRecordRecharge',
									component: routerMap['settingAdvancedMsgRecordRecharge'],
									meta: {
										title: '充值记录',
										leaf: false,
									},
									children: []
								},
								{
									path: '/setting-advanced-msg-recharge',
									name: 'settingAdvancedMsgRecharge',
									component: routerMap['settingAdvancedMsgRecharge'],
									meta: {
										title: '短信充值',
										leaf: false,
									},
									children: []
								},
							]
						},
					]
				},
				{
					path: '/setting-join',
					name: 'settingJoin',
					component: routerMap['settingJoin'],
					// redirect: '/setting-join-website',
					meta: {
						title: '接入设置',
						leaf: true,
					},
					children: [{
							path: '/setting-join-website',
							name: 'settingJoinWebsiteWrap',
							component: routerMap['settingJoinWebsite'],
							meta: {
								title: '网站接入',
								leaf: true,
								hasFourth: true
							},
							children: [{
									path: '/setting-join-website',
									name: 'settingJoinWebsite',
									component: routerMap['settingJoinWebsiteWeb'],
									meta: {
										title: '网站接入',
										leaf: false,
										hasFourth: true
									},
									children: []
								},
								{
									path: '/setting-join-website-pc',
									name: 'settingJoinWebsitePc',
									component: routerMap['settingJoinWebsitePc'],
									meta: {
										title: 'PC端聊天按钮',
										leaf: false,
										hideThirdMenu: true
									},
									children: []
								}, {
									path: '/setting-join-website-mob',
									name: 'settingJoinWebsiteMob',
									component: routerMap['settingJoinWebsiteMob'],
									meta: {
										title: '移动端聊天按钮',
										leaf: false,
										hideThirdMenu: true
									},
									children: []
								}
							]
						}, {
							path: '/setting-join-wxapp',
							name: 'settingJoinWxapp',
							component: routerMap['settingJoinWxapp'],
							meta: {
								title: '小程序接入',
								leaf: false,
							},
							children: []
						}, {
							path: '/setting-join-gzh',
							name: 'settingJoinGzhWrap',
							component: routerMap['settingJoinGzh'],
							meta: {
								title: '公众号接入',
								leaf: true,
								hasFourth: true
							},
							children: [{
								path: '/setting-join-gzh',
								name: 'settingJoinGzh',
								component: routerMap['settingJoinGzh'],
								meta: {
									title: '公众号接入',
									leaf: false,
								},
								children: []
							}, {
								path: '/setting-join-gzh-menu',
								name: 'settingJoinGzhMenu',
								component: routerMap['settingJoinGzhMenu'],
								meta: {
									title: '自定义微信菜单',
									leaf: false,
								},
								children: []
							}, {
								path: '/setting-join-gzh-reply',
								name: 'settingJoinGzhReply',
								component: routerMap['settingJoinGzhReply'],
								meta: {
									title: '自动回复',
									leaf: false,
								},
								children: []
							}, ]
						},
						{
							path: '/setting-join-weibo',
							name: 'settingJoinWeibo',
							component: routerMap['settingJoinWeibo'],
							meta: {
								title: '微博接入',
								leaf: false,
							},
							children: []
						},
					]
				},
				{
					path: '/setting-userinfo-account',
					name: 'settingUserInfoAccount',
					component: routerMap['settingPersonalAccount'],
					meta: {
						title: '个人账号',
						leaf: true,
					},
					children: [{
							path: '/setting-userinfo',
							name: 'settingUserInfoSetting',
							component: routerMap['settingUserInfo'],
							meta: {
								title: '账号设置',
								leaf: true,
								hasFourth: true
							},
							children: [{
								path: '/setting-userinfo',
								name: 'settingUserInfo',
								component: routerMap['settingUserInfoAccount'],
								meta: {
									title: '账号信息',
									leaf: false,
								},
								children: []
							}, {
								path: '/setting-userinfo-user',
								name: 'settingUserInfoUser',
								component: routerMap['settingUserInfoUser'],
								meta: {
									title: '个人信息',
									leaf: false,
								},
								children: []
							}, ]
						},
						{
							path: '/setting-change-pwd',
							name: 'settingChangePwd',
							component: routerMap['settingChangePwd'],
							meta: {
								title: '修改密码',
								leaf: false,
							},
							children: []
						},
					]
				},
				{
					path: '/business',
					name: 'business',
					component: routerMap['business'],
					meta: {
						title: '企业账户',
						leaf: true,
						icon: 'sidebar-team'
					},
					children: [{
						path: '/business-team',
						name: 'businessTeam',
						component: routerMap['businessTeam'],
						meta: {
							title: '团队信息',
							leaf: false,
						},
						children: []
					}, {
						path: '/business-contacts',
						name: 'businessContacts',
						component: routerMap['businessContacts'],
						meta: {
							title: '团队联系人',
							leaf: false,
						},
						children: []
					}]
				},
			]
		},
		{
			path: '/business-system',
			name: 'businessSystem',
			component: routerMap['businessCurrent'],
			meta: {
				title: '账号信息',
				msg: "账号信息",
				leaf: true,
				icon: 'sidebar-current'
			},
			children: [{
					path: '/business-service',
					name: 'businessServiceDetail',
					component: routerMap['businessService'],
					meta: {
						title: '版本信息',
						leaf: false,
					},
					children: []
				},
				{
					path: '/setting-notice',
					name: 'settingNotice',
					component: routerMap['settingNotice'],
					meta: {
						title: '系统公告',
						leaf: false,
					},
					children: []
				},
				{
					path: '/company-notice',
					name: 'companyNotice',
					component: routerMap['companyNotice'],
					meta: {
						title: '公司公告',
						leaf: false,
					},
					children: []
				}
			]
		},
	]
}, ]

export const errorRoute = [{
		path: '/no-router',
		component: routerMap['errorNoRouter'],
		meta: {
			title: '菜单异常',
			leaf: false,
		},
		hidden: true
	},
	{
		path: '*',
		redirect: '/error',
		hidden: true
	},
	{
		path: '/error',
		component: routerMap['error404'],
		meta: {
			title: '出错了',
			leaf: false,
		},
		hidden: true
	}
]

const createRouter = () => new Router({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
// 重置路由
export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
}

export default router
